import { PageController } from '@client/components/_core/layout/PageController';
import { Tabs } from '@client/components/_core/navigation/Tabs';
import { createFileRoute } from '@tanstack/react-router';
import { Settings } from 'lucide-react';

export const Route = createFileRoute('/admin-console/advanced/app-settings')({
    staticData: {
        ui: {
            icon: Settings,
            title: 'App settings',
            widthVariant: 'default',
            menuDescription: 'Application settings',
        },
    },
    component: AppSettings,
});

function AppSettings() {
    return (
        <PageController route={Route}>
            <Tabs
                items={[
                    { label: 'All', to: '/admin-console/advanced/app-settings/all' },
                    { label: 'Well-known', to: '/admin-console/advanced/app-settings/well-known' },
                ]}
            />
        </PageController>
    );
}
